// extracted by mini-css-extract-plugin
export default {"component":"ImageCard_component__6+Qp3","variantReverse":"ImageCard_variantReverse__0mf9n"};